var map = {
	"./US-in-box.png": 8628,
	"./aGate.png": 2187,
	"./aPower-x1.png": 9747,
	"./add-icon.svg": 6745,
	"./air-conditioner-active.svg": 5250,
	"./air-conditioner.svg": 7290,
	"./arrow-dashed-white.svg": 8493,
	"./arrow-down-solid.svg": 5808,
	"./banner.jpg": 7146,
	"./cart.svg": 9898,
	"./coffee-machine-active.svg": 3174,
	"./coffee-machine.svg": 5610,
	"./default-active.svg": 7459,
	"./default.svg": 8838,
	"./dishwasher-active.svg": 3325,
	"./dishwasher.svg": 3232,
	"./electric-dryer-active.svg": 2661,
	"./electric-dryer.svg": 3893,
	"./electric-oven-active.svg": 4115,
	"./electric-oven.svg": 946,
	"./email.svg": 9168,
	"./faceb.svg": 8973,
	"./feedback-arrow.svg": 8119,
	"./footer-logo.png": 8055,
	"./footlogo2.svg": 9497,
	"./footlogo3.svg": 4907,
	"./hair-dryer-active.svg": 5225,
	"./hair-dryer.svg": 5582,
	"./heat-pump-active.svg": 2848,
	"./heat-pump.svg": 3592,
	"./in.svg": 4100,
	"./instagram.svg": 2770,
	"./laptop-pc-active.svg": 9640,
	"./laptop-pc.svg": 8305,
	"./light-active.svg": 8956,
	"./light.svg": 8988,
	"./logo.png": 6949,
	"./mail.svg": 2059,
	"./menu-close.svg": 6492,
	"./menu.svg": 3898,
	"./microwave-active.svg": 3595,
	"./microwave.svg": 2901,
	"./mobile-charge-active.svg": 2308,
	"./mobile-charge.svg": 9362,
	"./phone.svg": 6289,
	"./pool-pump-active.svg": 128,
	"./pool-pump.svg": 9730,
	"./refrigerator-active.svg": 778,
	"./refrigerator.svg": 2126,
	"./search-wap.svg": 8834,
	"./search.svg": 1238,
	"./television-active.svg": 6309,
	"./television.svg": 861,
	"./train.svg": 1358,
	"./twitte.svg": 655,
	"./vacuum-cleaner-active.svg": 6087,
	"./vacuum-cleaner.svg": 8798,
	"./washing-machine-active.svg": 4265,
	"./washing-machine.svg": 8590,
	"./website-icon.svg": 6570,
	"./well-pump-active.svg": 2062,
	"./well-pump.svg": 3440,
	"./wifi-router-active.svg": 6908,
	"./wifi-router.svg": 4646,
	"./yutob.svg": 1734
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;